<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP" id="pt1"> </p>
<p class="PN"><span epub:type="pagebreak" id="pg_13" title="13"><span href="#/xhtml/contents#p_pt1" title="Link target outside of Sample"><span class="ePub-I">Laceleaf</span></span></span></p>
<p class="Part-Opening-Text-No-Indent-potx1"><span class="ePub-SC">DESCRIPTION:</span> Attractive wide-ranging plant with delicate green leaves and clumps of small white flowers.</p>
<p class="Part-Opening-Text-potx"><span class="ePub-SC">SYMPTOMS:</span> Dilated pupils, rapid weak pulse, and a peripheral numbness that spreads inward, resulting in respiratory paralysis and heart failure.</p>
<p class="Part-Opening-Text-potx"><span class="ePub-SC">PROOFING CUES:</span> Mild, musty smell and pleasant flavor, often mistaken for harmless cousins.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?4a2a1b1e